import { useEffect } from 'react'
import { Redirect } from 'react-router-dom'
import useAuthStore from 'store/auth'

const SignOutPage = () => {
  const signOut = useAuthStore((state) => state.signOut)

  useEffect(() => {
    signOut()
  }, [signOut])

  return <Redirect to="/sign-in" />
}

export default SignOutPage
